// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13Qd6","placeholdersHeader":"styles_placeholdersHeader__3el4d","editorStyle":"styles_editorStyle__2WMvN","placeholdersBox":"styles_placeholdersBox__3LyHp"};